/*
* IE11 support
* Metoda find() zwraca pierwszy element tablicy, który spełnia warunek podanej funkcji testującej.
* W przeciwnym razie, gdy żaden element tablicy nie spełni warunku, zwracana jest wartość undefined.
* https://developer.mozilla.org/pl/docs/Web/JavaScript/Referencje/Obiekty/Array/find
 */

if (!Array.prototype.find) {
	Array.prototype.find = function(predicate) {
		if (this == null) {
			throw new TypeError('Array.prototype.find called on null or undefined');
		}
		if (typeof predicate !== 'function') {
			throw new TypeError('predicate must be a function');
		}
		var list = Object(this);
		var length = list.length >>> 0;
		var thisArg = arguments[1];
		var value;

		for (var i = 0; i < length; i++) {
			value = list[i];
			if (predicate.call(thisArg, value, i, list)) {
				return value;
			}
		}
		return undefined;
	};
}
